import Breadcrumbs from "./Breadcrumbs";

export default function PageHeader({ eyebrow, title, description, breadcrumbs = [], children }) {
  return (
    <section className="relative bg-ink-900 text-white border-b-2 border-green-700 overflow-hidden" data-testid="page-header">
      <div className="absolute inset-0 pitch-grid opacity-40 pointer-events-none" />
      <div className="wrap relative py-12 md:py-20">
        <Breadcrumbs items={breadcrumbs} light />
        <div className="mt-6 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-3xl">
            {eyebrow && <div className="eyebrow-light mb-4">{eyebrow}</div>}
            <h1 className="display-lg text-white">{title}</h1>
            {description && <p className="mt-5 text-white/70 leading-relaxed max-w-2xl">{description}</p>}
          </div>
          {children && <div className="flex-shrink-0">{children}</div>}
        </div>
      </div>
    </section>
  );
}
